import React, { Component } from "react";
import { connect } from "react-redux";
import { LoginLink } from "./LoginLink";
import { UserMenu } from "./UserMenu";
import { Link } from "react-router-dom";
import { OrgDropdown } from "../org/OrgDropdown";
import { AdminMenu } from "./AdminMenu";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { dealjacket: {} };
  }

  componentDidMount() { }

  render() {
    const { org, authentication } = this.props;
    const org_id =
      org?.current_org_id === null
        ? authentication?.user?.org_id
        : org.current_org_id;
    const current_org = org.list?.filter(
      (o) => o.org_id == org_id
    )[0];
    const org_type = current_org?.org_type;
    const is_dealer = org_type !== 'Non-Dealer';
    const is_upload_only = authentication?.user?.roles?.find(permitted => "UPLOAD_ONLY" === permitted.toUpperCase());

    const showUserIcon = () => {
      return authentication?.user ? authentication.first_name : "Login";
    };

    return (
      <div className="breadcrumb">
        {authentication?.user?.email && (
          <>
            <ul>
              {!(is_upload_only) && (
                <>
                  <li>
                    {<Link to={"/org/" + org_id + "/dealjackets"}>files</Link>}
                  </li>
                  <li>
                    <Link to={"/org/" + org_id + "/manifest"}>manifest</Link>
                  </li>
                </>
              )}
              <li>
                <Link to={"/org/" + org_id + "/contact"}>contact</Link>
              </li>

              {
                (authentication?.user?.org_id === 1 || authentication?.user?.roles?.includes("WRITE") || is_upload_only) &&
                <li className="admin-menu">
                  <a className="loginlink">
                    upload&nbsp;&nbsp;<span className="arrow-down"></span>
                  </a>
                  <div className="admin-content">

                    <Link to="/upload" action="logs">
                      upload local files
                    </Link>
                    <Link to="/dwt" action="logs">
                      scan and upload
                    </Link>

                  </div>
                </li>
              }


              {authentication?.user?.roles?.find(permitted => "ADMIN" === permitted.toUpperCase()) && (
                <>
                  <AdminMenu />
                </>
              )}
              {authentication?.user?.roles?.find(permitted => ["MANAGER"].find(role => role === permitted.toUpperCase())) && (

                <li>
                  <Link to={"/org/" + org_id + "/dl_insurance/"}>
                    DL &amp; Insurance
                  </Link>
                </li>

              )}
            </ul>
            {authentication?.user?.orgs && (
              <span className="orgdropdown">
                <OrgDropdown />
              </span>
            )}
          </>
        )}
        {!authentication?.user?.email && (
          <ul>
            <li>
              <Link to={"/login"}>home</Link>
            </li>
            <li>
              <a href="https://www.gotagtech.com">about</a>
            </li>
            <li>
              <Link to={"/contact"}>contact</Link>
            </li>
          </ul>
        )}

        <span className="usericon">
          {authentication?.user && (
            <>
              <UserMenu email={authentication.user.email} />
            </>
          )}
          {!authentication?.user && <LoginLink />}
        </span>

        <span className="right"></span>

        <span className="subheader"></span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { org, authentication } = state;
  return { org, authentication };
}

const connectedMenu = connect(mapStateToProps)(Menu);
export { connectedMenu as Menu };
